import { fetchClient } from "@/lib/fetchClient";
import type { Me } from "@/types/resources";

export async function getMe(): Promise<Me> {
  const { data } = await fetchClient.GET("/accounts/me");
  if (data === undefined) {
    throw new Error("");
  }

  return data;
}
